/**
* @file 公共组件-tabFrame
**/
<template>
  <div id="tabFrame">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane v-for="item in tabs" :key="item.path || item.name" :name="item.name">
        <template slot="label">
          <i v-if="item.icon" :class="item.icon" style="margin-right: 4px"></i>{{ item.label }}
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabFrame',
  props: {
    // 传入的tabs各项信息
    tabs: {
      default() {
        return []
      }
    }
  },
  data() {
    return {
      // 激活的tab项
      tabAction: this.tabs[0].name
    }
  },
  watch: {
    tabAction(val) {
      this.$router.push(val)
    },
    '$route': {
      handler(val) {
        this.tabAction = val.path
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="less">
#tabFrame {
  height: 100%;

  .content {
    height: calc(100% - 40px);

    &>div {
      height: 100%;
    }
  }

  // .el-tabs--card>.el-tabs__header .el-tabs__nav {
  //   border: none;
  // }

  // .el-tabs--card>.el-tabs__header .el-tabs__item,
  // .el-tabs--card>.el-tabs__header .el-tabs__item:first-child {
  //   border-left: 1px solid #fff;
  //   border-right: 1px solid #fff
  // }

  // .el-tabs--card {
  //   .el-tabs__item {
  //     font-size: 14px;
  //   }

  //   .el-tabs__header {
  //     .is-active {
  //       border-left: 1px solid #dcdfe6 !important;
  //       border-top: 1px solid #dcdfe6 !important;
  //       border-right: 1px solid #dcdfe6 !important;
  //       border-bottom-color: #fff;
  //       position: relative;
  //       border-radius: 6px 6px 0 0;
  //     }

  //     .is-active::after {
  //       content: '';
  //       position: absolute;
  //       left: 0;
  //       height: 3px;
  //       width: 100%;
  //       bottom: -2px;
  //       background: rgba(0, 0, 0, 0);
  //     }
  //   }
  // }
}
</style>
